class EmailAddressesModel {
    public static getDefault(): any {
        return Immutable.fromJS({
            Emails: Immutable.List([]),
            IsNotifiedByEmail: false
        });
    }
}

export { EmailAddressesModel };
